import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/auth'

const firebaseConfig = {
  apiKey: 'AIzaSyDsmn0pXUt7DyRDVwwSR0QHEHItvGyBke0',
  authDomain: 'nutricia-9fccb.firebaseapp.com',
  projectId: 'nutricia-9fccb',
  storageBucket: 'nutricia-9fccb.appspot.com',
  messagingSenderId: '996675744207',
  appId: '1:996675744207:web:c4b66fabaee6ebb2dee2ba',
  // measurementId: 'G-MYCN9XLCDX',
}

firebase.initializeApp(firebaseConfig)

const firebaseDb = firebase.database()
const firebaseAuth = firebase.auth()

const ChatDb = firebaseDb.ref('chat')
const ChatKfairDb = firebaseDb.ref('chatAuditorium')
const ChatMcDb = firebaseDb.ref('chatMc')
const NoticeDb = firebaseDb.ref('notice')
const AccessDb = firebaseDb.ref('access')
const NotificationDb = firebaseDb.ref('pushNotifications')

export {
  firebaseDb,
  firebaseAuth,
  ChatDb,
  ChatKfairDb,
  ChatMcDb,
  NoticeDb,
  NotificationDb,
  AccessDb, 
}
